// CSS
import 'src/styles/global.scss';

/**
 * Animation library
 */

// Export for other modules
export * from "gsap";
export * from "gsap/ScrollToPlugin";
export * from "gsap/ScrollTrigger";

// Import the core library and specific plugins
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register plugins so that they are not dropped during build
gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);